import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const locations = [
  {
    city: "Charlotte",
    address: "2740 East WT Harris Blvd, Suite 200",
    cityState: "Charlotte, NC 28213",
    phone: "(704) 599-3355",
    phonePure: "7045993355"
  },
  {
    city: "Winston-Salem",
    address: "326 S. Main Street",
    cityState: "Winston-Salem, NC 27101",
    phone: "(336) 761-0366",
    phonePure: "3367610366"
  },
  {
    city: "Charlotte (SouthPark)",
    address: "6000 Fairview Road, Suite 1200",
    cityState: "Charlotte, NC 28210",
    phone: "(704) 599-3355",
    phonePure: "7045993355",
    note: "By Appointment Only"
  },
  {
    city: "Mooresville",
    address: "121 Rolling Hill Road",
    cityState: "Mooresville, NC 28117",
    phone: "(704) 663-6213",
    phonePure: "7046636213",
    note: "By Appointment Only"
  }
];

export const WelcomeFooter = () => {
  return (
    <footer className="bg-[#07182F] text-white" data-testid="welcome-footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14">
        {/* Brand + Email */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-10">
          <div className="flex items-center gap-4">
            <Link to="/" className="inline-flex items-center group" data-testid="welcome-footer-logo">
              <img
                src="/brand/kgob-logo-dark.svg"
                alt="Kohari Gonzalez Oneyear & Brown CPAs & Advisors"
                className="h-11 w-auto object-contain transition-transform duration-300 group-hover:scale-[1.03]"
              />
            </Link>
            <p className="text-sm text-white/50 italic">Luxury Advisory. Precision Compliance.</p>
          </div>
          <a
            href="mailto:connect@kgob.com"
            className="inline-flex items-center gap-2 text-sm text-[#D4AF37] hover:text-[#E3C96E] transition-colors"
            data-testid="footer-email"
          >
            <Mail className="h-4 w-4" />
            connect@kgob.com
          </a>
        </div>

        {/* All 4 locations in uniform grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-10">
          {locations.map((loc) => (
            <div key={loc.city} data-testid={`footer-location-${loc.city.toLowerCase().replace(/[^a-z]/g, '')}`}>
              <h4 className="text-sm font-semibold text-white mb-2 flex items-center gap-2">
                <MapPin className="h-3.5 w-3.5 text-[#D4AF37] flex-shrink-0" />
                {loc.city}
              </h4>
              <address className="not-italic text-xs text-white/50 space-y-1 ml-[22px]">
                <p>{loc.address}</p>
                <p>{loc.cityState}</p>
                {loc.note && <p className="text-[#D4AF37]/50 italic">{loc.note}</p>}
              </address>
              <a data-testid="welcome-footer-a-1"
                href={`tel:${loc.phonePure}`}
                className="inline-flex items-center gap-1 text-xs text-white/60 hover:text-white mt-2 ml-[22px] transition-colors"
              >
                <Phone className="h-3 w-3" />
                {loc.phone}
              </a>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-xs text-white/40">
              &copy; {new Date().getFullYear()} Kohari Gonzalez Oneyear & Brown PLLC. All rights reserved.
            </p>
            <div className="flex items-center gap-5 text-xs text-white/40">
              <Link data-testid="welcome-footer-link-5" to="/privacy-policy" className="hover:text-white transition-colors">Privacy</Link>
              <Link data-testid="welcome-footer-link-4" to="/our-story" className="hover:text-white transition-colors">About</Link>
              <Link data-testid="welcome-footer-link-3" to="/services" className="hover:text-white transition-colors">Services</Link>
              <Link data-testid="welcome-footer-link-2" to="/community" className="hover:text-white transition-colors">Blog</Link>
              <Link data-testid="welcome-footer-link-1" to="/contact" className="hover:text-white transition-colors">Careers</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
